import React from 'react';

const Icon = (props) => {
  const { iconClass, iconCode, onClick, className } = props;

  return (
    <span
      className={`material-symbols-outlined ${iconClass || ''} ${
        className || ''
      }`}
      onClick={onClick}
    >
      {iconCode}
    </span>
  );
};

export default Icon;
